
<qr-scanner
        [debug]="false"
        [canvasWidth]="1080"
        [canvasHeight]="720"
        [stopAfterScan]="true"
        [updateTime]="500">
</qr-scanner>
